import { render } from "./PricingTableModal.vue?vue&type=template&id=3c53a09a&scoped=true"
import script from "./PricingTableModal.vue?vue&type=script&lang=js"
export * from "./PricingTableModal.vue?vue&type=script&lang=js"

import "./PricingTableModal.vue?vue&type=style&index=0&id=3c53a09a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c53a09a"]])

export default __exports__